import { Notification, Loading } from 'element-ui';
import { DBS, SQS, BKS } from '@/data/MENU_CHECK';

const utils = {

	//生成时间戳字符串
	timestamp() {
		return Date.parse(new Date());
	},

	// 处理文件大小，转成KB,MB，GB
	formatSize(size) {
		if (size < 1024) {
			return size + 'KB';
		} else if (size < 1024 * 1024) {
			return (size / 1024).toFixed(2) + 'KB';
		} else if (size < 1024 * 1024 * 1024) {
			return (size / (1024 * 1024)).toFixed(2) + 'MB';
		} else if (size < 1024 * 1024 * 1024 * 1024){
			return (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
		} else  {
			return (size / (1024 * 1024 * 1024)).toFixed(2) + 'TB';
		}
	},

	// 处理文件大小（KB输入），带单位空格和null检查
	formatSizeKB(size) {
		if (size == null || size === '') return '--';
		if (size < 1024) return size + ' KB';
		if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB';
		if (size < 1024 * 1024 * 1024) return (size / (1024 * 1024)).toFixed(2) + ' MB';
		return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
	},

	// 处理文件大小（Byte输入），带单位空格和null检查
	formatSizeBytes(size) {
		if (size == null || size === '') return '--';
		if (size < 1024) return size + ' KB';
		if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB';
		if (size < 1024 * 1024 * 1024) return (size / (1024 * 1024)).toFixed(2) + ' MB';
		return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
	},

	// 根据 docMode（dictValue）反查 dictLabel，返回扩展名（不带点，小写，如 pdf）
	getExtByDocMode(docMode, docTypeList) {
		if (docMode == null || docMode === '') return '';
		const key = String(docMode);
		const item = (docTypeList || []).find(t => t && String(t.dictValue) === key);
		if (!item || !item.dictLabel) return '';
		return String(item.dictLabel).replace(/^\./, '').toLowerCase();
	},

	//法规标准 -- 高亮（暂未启用）
	highlightKeywords(data, keyword, fields = ['standardName', 'standardSummary']) {
		if (!keyword) {
			return data;
		}
		return data;
	},

	// 检查是否在数据库中
	isinDBS(cpm) {
		for (let idx in DBS) {
			if (cpm.path.includes(DBS[idx])) {
				return true;
			}
		}

		return false;
	},

	// 检查是否在社区中
	isinSQS(cpm) {
		for (let idx in SQS) {
			if (cpm.path.includes(SQS[idx])) {
				return true;
			}
		}

		return false;
	},

	// 检查是否在社区中
	isinBKS(cpm) {
		for (let idx in BKS) {
			if (cpm.path.includes(BKS[idx])) {
				return true;
			}
		}

		return false;
	},

	// 成功消息提示
	showSuccess(msg) {
		Notification({
			title: '成功',
			message: msg,
			type: 'success'
		});
	},

	// 警告消息提示
	showWarning(msg) {
		Notification({
			title: '警告',
			message: msg,
			type: 'warning'
		});
	},

	// 普通消息提示
	showInfo(msg) {
		Notification({
			title: '提示',
			message: msg,
			type: 'info'
		});
	},

	// 开启loading
	showLoading(msg) {
		const loading = Loading.service({
			text: msg
		});
	},

	//获取当前ip地址
	getIP(callback) {
		let recode = {};
		let RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
		// 如果不存在则使用一个iframe绕过
		if (!RTCPeerConnection) {
			// 因为这里用到了iframe，所以在调用这个方法的script上必须有一个iframe标签
			// <iframe id="iframe" sandbox="allow-same-origin"></iframe>
			let win = iframe.contentWindow;
			RTCPeerConnection = win.RTCPeerConnection || win.mozRTCPeerConnection || win.webkitRTCPeerConnection;
		}

		//创建实例，生成连接
		let pc = new RTCPeerConnection();

		// 匹配字符串中符合ip地址的字段
		function handleCandidate(candidate) {
			let ip_regexp = /([0-9]{1,3}(\.[0-9]{1,3}){3}|([a-f0-9]{1,4}((:[a-f0-9]{1,4}){7}|:+[a-f0-9]{1,4}){6}))/;
			let ip_isMatch = candidate.match(ip_regexp)[1];
			if (!recode[ip_isMatch]) {
				callback(ip_isMatch);
				recode[ip_isMatch] = true;
			}
		}

		//监听icecandidate事件
		pc.onicecandidate = ice => {
			if (ice.candidate) {
				handleCandidate(ice.candidate.candidate);
			}
		};
		//建立一个伪数据的通道
		pc.createDataChannel('');
		pc.createOffer(
			res => {
				pc.setLocalDescription(res);
			},
			() => {}
		);

		//延迟，让一切都能完成
		setTimeout(() => {
			let lines = pc.localDescription.sdp.split('\n');
			lines.forEach(item => {
				if (item.indexOf('a=candidate:') === 0) {
					handleCandidate(item);
				}
			});
		}, 1000);
	}
};

// 导出utils 工具方法
export default utils;
